/**
 * The three pairings of the same four — BUILD_PLAN 1.6, FR-ENTRY-4.
 *
 * A copy of the rule in @core-baddy/core, because the web bundle does not
 * import server packages and this must work with no connection: swapping
 * partners is a local rearrangement of four names, not a request.
 *
 * The canonical sort is the part that matters. Deriving the list from the
 * current arrangement makes it shift under its own feet, so three taps land
 * somewhere arbitrary instead of back where they started. Sorting makes the
 * cycle a genuine cycle. There is a test for exactly that in
 * packages/core/src/__tests__/rotation.test.ts.
 */

export function pairingsOf(four: readonly string[]): Array<{ sideA: string[]; sideB: string[] }> {
  const [a, b, c, d] = [...four].sort();
  return [
    { sideA: [a, b], sideB: [c, d] },
    { sideA: [a, c], sideB: [b, d] },
    { sideA: [a, d], sideB: [b, c] },
  ];
}

export function nextPairing(
  sideA: readonly string[],
  sideB: readonly string[],
): { sideA: string[]; sideB: string[] } {
  const pairings = pairingsOf([...sideA, ...sideB]);
  const key = (p: { sideA: string[]; sideB: string[] }) =>
    [[...p.sideA].sort().join("|"), [...p.sideB].sort().join("|")].sort().join("//");

  const current = pairings.findIndex(
    (p) => key(p) === key({ sideA: [...sideA], sideB: [...sideB] }),
  );
  return pairings[(current + 1) % pairings.length];
}
